// Rende cliccabili SOLO gli URL http/https presenti in un testo, senza dangerouslySetInnerHTML.
// Il testo del messaggio resta testo sicuro: si spezzano esclusivamente gli URL validi in <a>.
// I link si aprono in una nuova scheda con attributi di sicurezza (no accesso a window.opener).
const URL_RE = /https?:\/\/[^\s<>]+/gi;
const TRAIL_RE = /[)\]\}.,;:!?'"»›>]+$/;

// Abbrevia esteticamente il TESTO mostrato (dominio + path troncato con ellissi) mantenendo l'href completo e apribile.
// Abbreviazione attiva solo se maxLen è finito (opt-in): le chat continuano a mostrare l'URL per intero.
function shortLabel(url, maxLen) {
  if (!Number.isFinite(maxLen)) return url;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    const rest = (u.pathname + u.search + u.hash).replace(/\/$/, "");
    const full = rest ? host + rest : host;
    if (full.length <= maxLen) return full;
    const keep = Math.max(0, maxLen - host.length - 2);
    return keep > 0 ? host + "…" + rest.slice(rest.length - keep) : host + "/…";
  } catch {
    return url.length > maxLen ? url.slice(0, maxLen - 1) + "…" : url;
  }
}

export function Linkify({ text, linkClassName = "underline break-words", maxLen = Infinity }) {
  if (!text) return null;
  const nodes = [];
  let last = 0, key = 0, m;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text)) !== null) {
    let url = m[0];
    let trail = "";
    const tp = url.match(TRAIL_RE); // punteggiatura/parentesi finali non fanno parte dell'URL
    if (tp) { trail = tp[0]; url = url.slice(0, url.length - trail.length); }
    if (!url) { continue; }
    if (m.index > last) nodes.push(text.slice(last, m.index));
    // Solo http/https (garantito dalla regex): javascript:, data:, file:, vbscript: non vengono mai resi cliccabili.
    nodes.push(
      <a key={`lk${key++}`} href={url} target="_blank" rel="noopener noreferrer nofollow ugc"
        className={linkClassName} title={url} onClick={(e) => e.stopPropagation()} data-testid="chat-link">{shortLabel(url, maxLen)}</a>);
    if (trail) nodes.push(trail);
    last = m.index + m[0].length;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return <>{nodes}</>;
}
